import {
  CadPlugin,
  CameraPlugin,
  ControlPlugin,
  InputPlugin,
  PickingPlugin,
  RenderPlugin,
  SelectionPlugin,
  ViewPlugin,
  type Plugin,
} from '@sharefe/share3d-engine'

/**
 * 阶段 5 CAD WebGPU 最小验证插件集。
 *
 * 不包含 PointCloud、SpatialQuery 与 Character 等尚未完成 WebGPU 迁移的主体，
 * 仅保留 CadPlugin 的必需服务依赖。该集合只服务于 example 验证 route，不改变公开 preset。
 */
export function createCadFixturePlugins(): Plugin[] {
  return [
    new ViewPlugin(),
    new CameraPlugin(),
    new InputPlugin(),
    new ControlPlugin(),
    new PickingPlugin(),
    new SelectionPlugin(),
    new RenderPlugin(),
    new CadPlugin(),
  ]
}
